module.exports = {
  localstorage: require("./localstorage"),
};



// WEBPACK FOOTER //
// ../shared/optilit-frontend-helpers/src/index.js